import { z } from "zod";

/** Session-only preview state. Never persisted into the backend wheel slice. */
export const LocalHolyWheelSliceSchema = z.strictObject({
    configurationKey: z.string().nullable(),
    storedSpins: z.string().regex(/^(0|[1-9][0-9]*)$/),
    freeSpins: z.union([z.literal(0), z.literal(1)]),
    nextFreeSpinAt: z.number().nullable(),
    multiplier: z.number().int().min(1).max(100),
    sequence: z.number().int().nonnegative(),
});
export type LocalHolyWheelSlice = z.infer<typeof LocalHolyWheelSliceSchema>;
